export const addAddress = async (axios, address) => {
  const result = await axios.post(`/PROFILE_URL/address`, {
    ...address,
    friendly_name: '',
    address_uuid: '',
  })

  return result?.data
}

export const updateAddress = async (axios, address) => {
  const payload = {
    ...address,
  }
  const result = await axios.patch(`/PROFILE_URL/address`, payload)
  return result?.data
}

export const deleteAddress = (axios, address) => {
  return axios.$delete(`/PROFILE_URL/address/${address.address_uuid}`)
}
